import { render, staticRenderFns } from "./PlanejamentoList.vue?vue&type=template&id=913e2576&"
import script from "./PlanejamentoList.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports